import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/whitepapers/")({
  head: () => buildRouteHead("/zh-cn/whitepapers/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/zh-cn/downloads", replace: true, statusCode: 301 });
  },
});
